import React from 'react';
import Section from "../../../components/Section";

const SectionForm = ({icon, label, actions, children, footer}) => {
    return <Section
        footerContent={footer}
        titleContent={<div className='section-form__header'>
            <div className='section-form__icon-label'>
                {icon}
                <div className='section-form__label'>{label}</div>
            </div>
            {actions && actions}
        </div>}
    >
        {children}
    </Section>
};

export default SectionForm;


// WEBPACK FOOTER //
// ./App/pages/parcels/form_v3/sectionForm.jsx